__turbopack_context__.v({
  "advertName": "CAdvertisements-module__FX2xgq__advertName",
  "btnDanger": "CAdvertisements-module__FX2xgq__btnDanger",
  "btnLink": "CAdvertisements-module__FX2xgq__btnLink",
  "btnPrimary": "CAdvertisements-module__FX2xgq__btnPrimary",
  "btnSecondary": "CAdvertisements-module__FX2xgq__btnSecondary",
  "empty": "CAdvertisements-module__FX2xgq__empty",
  "emptyRow": "CAdvertisements-module__FX2xgq__emptyRow",
  "form": "CAdvertisements-module__FX2xgq__form",
  "formActions": "CAdvertisements-module__FX2xgq__formActions",
  "formRow": "CAdvertisements-module__FX2xgq__formRow",
  "formTitle": "CAdvertisements-module__FX2xgq__formTitle",
  "imageActions": "CAdvertisements-module__FX2xgq__imageActions",
  "imageGrid": "CAdvertisements-module__FX2xgq__imageGrid",
  "imageItem": "CAdvertisements-module__FX2xgq__imageItem",
  "imageItemMain": "CAdvertisements-module__FX2xgq__imageItemMain",
  "imagesSection": "CAdvertisements-module__FX2xgq__imagesSection",
  "imagesToolbar": "CAdvertisements-module__FX2xgq__imagesToolbar",
  "listToolbar": "CAdvertisements-module__FX2xgq__listToolbar",
  "mainBadge": "CAdvertisements-module__FX2xgq__mainBadge",
  "nameCell": "CAdvertisements-module__FX2xgq__nameCell",
  "pageButton": "CAdvertisements-module__FX2xgq__pageButton",
  "pageInfo": "CAdvertisements-module__FX2xgq__pageInfo",
  "pagination": "CAdvertisements-module__FX2xgq__pagination",
  "priceTag": "CAdvertisements-module__FX2xgq__priceTag",
  "root": "CAdvertisements-module__FX2xgq__root",
  "rowActions": "CAdvertisements-module__FX2xgq__rowActions",
  "rowSkeleton": "CAdvertisements-module__FX2xgq__rowSkeleton",
  "searchWrap": "CAdvertisements-module__FX2xgq__searchWrap",
  "sortIcon": "CAdvertisements-module__FX2xgq__sortIcon",
  "sortIconActive": "CAdvertisements-module__FX2xgq__sortIconActive",
  "suggestActions": "CAdvertisements-module__FX2xgq__suggestActions",
  "suggestHint": "CAdvertisements-module__FX2xgq__suggestHint",
  "suggestPanel": "CAdvertisements-module__FX2xgq__suggestPanel",
  "suggestRow": "CAdvertisements-module__FX2xgq__suggestRow",
  "suggestTitle": "CAdvertisements-module__FX2xgq__suggestTitle",
  "table": "CAdvertisements-module__FX2xgq__table",
  "tableSkeleton": "CAdvertisements-module__FX2xgq__tableSkeleton",
  "tableWrap": "CAdvertisements-module__FX2xgq__tableWrap",
  "thInner": "CAdvertisements-module__FX2xgq__thInner",
  "thSortable": "CAdvertisements-module__FX2xgq__thSortable",
  "thumb": "CAdvertisements-module__FX2xgq__thumb",
});
